import styled, { css } from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PlaceAutcompleteDropdownContainer = styled.div`
  position: relative;
`;

export const $PlaceAutcompleteDropdown = styled.ul`
  background: ${({ theme }) => theme.colors.white};
  list-style: none;
  margin-top: ${spacing('xxs')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-color: ${({ theme }) => theme.colors.default};
  z-index: 10;
  border-width: ${spacing('px')};
  border-style: solid;
  padding: 0;
  width: 100%;

  border-radius: ${({ theme }) => theme.tw.radius.sm};
  overflow: hidden;

  box-shadow: ${({ theme }) =>
    theme.shadows.elevation__1.replace('box-shadow: ', '')};
`;

export const $PlaceAutcompleteItem = styled.li``;
const optionMixin = css<{ $isSelected?: boolean }>`
  padding: ${spacing('lg')};
  background: ${({ $isSelected = false, theme }) =>
    $isSelected ? theme.colors.default : 'none'};
  outline: 0;
  border: 0;
  width: 100%;
  text-align: left;
`;

export const $PlaceAutcompleteButton = styled.button<{ $isSelected?: boolean }>`
  ${optionMixin};
  cursor: pointer;
  &:hover,
  &:focus {
    outline: 0;
    border: 0;
    background: ${({ theme }) => theme.colors.default};
  }
`;
export const $PlaceAutcompleteLoading = styled.div<{ $isSelected?: boolean }>`
  ${optionMixin}
`;
